var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 80,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_217_47",
    transform: "translate(0 0.1) scale(0.0104167 0.00833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_217_47",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADrklEQVR4nO3czUtUYRTH8d+5d1DJQrFZl3uDIAIXZlHNYEnbXLaZlPbSX1CLFkFEgaTWKiiyZVTOTEUWkQuhRbaWWlaYvUCMzpwW+vRCvszz3Due+8w9H3Ajc+Zezlev46AXUEoppZRSSimllFJpQVGfoPBsel8QhGfByIHQDaA9hvNKsh9gLIBQrtWqkzePDryN8mTOAU7P32vp/NR1BcA5AEGUk/BYFeCxL9nF0ameoYrLEzgFWFv+IwDHXOabDYOeLGU/D7pEcPrKXfvK1+WvIfDxzo+7L7vNWlq75r8BELocsIlVEQb7Jw4dm7cZsv4OoCAchi5/PSFWuGA7ZB8AyNnOpAUR8rYzLj8D9jjMpAKD99rOuATY6TCTFrtsB9L6+j0xNIAwDSBMAwjTAMI0gDANIEwDCNMAwjSAMA0gTAMI0wDCPA/As6sf/vI5wFwmaDtJFQwAeC19Mq58DTCXCVrzY/39i+P5/BJV+AQ8jeBjgN/LN5/wOYJvAf5bvuFrBJ8CbLh8w8cIvgTYcvmGbxF8CFD38g2fIiQ9gPXyDV8iJDmA8/INHyIkNUDk5RtJj5DAADxLFT5ez/JHSqWOkVKpY6vH/YmQvLctkhZgLhO0nRzP55e2euBIqdTBLZjmFnpaePW4a6vHr0ZI3tsWSQpQ92XHLB+gXgAHguVMqf4IybocJSWA6/INbyMkIUDU5RteRpAOENfyDe8iSAaIe/mGVxGkAjRq+YY3ESQCNHr5hhcRtj0AEy5tw/KNA8Fy+LDuX9aIL0Y4lpNtD0CM28Mvyqc2e0xMyzdH7K3nl7XCTLGPme5EP54diUtQK2q4v1GEeJf/26aXo8JMsS/g4BEc/scrKqkfwutGaNDyjXUjSC4fkH0Z+k+EBi/f+CeC9PIBh1sVDD8vc8zn8JOYzjDVRhu8/L/wLBEuMNNdxPxvtxNHclY7zcR5cEdtTHwvhlsXWaBeZjzYxgNuSPqtiNTTAMI0gDANIEwDCNMAwjSAMA0gTAMI0wDCNIAwDSBMAwjTAMI0gDCXAN9iP4vm8dV2wCXAB4eZVCDQe9sZh3tHc9F2Ji1q4GnbGesAHIaTAKq2cylQDQm3bIesA6zeH5/HbOdS4PqNw7l3tkNOr4K+ZBdHGfTEZbYpEcrU3nneZdQpwFTPUGUp+3kQTNeQ7svRCoCrtKNzcPzgwWWXJ4j8tyDDL5/2YIULRMgzuBvNf3v77wRaYOJiANx0uewopZRSSimllFJKqXT6BStapLvZm0CnAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.7ef1c6f30d14c313e3e0689c0dc0b5f1.svg";
export { ForwardRef as ReactComponent };